/**
 * App.jsx — Point d'entrée de l'application React
 *
 * Ce fichier définit toutes les routes de la plateforme UltimateXDrive.
 * Chaque <Route> associe une URL à un composant de page.
 * BrowserRouter gère la navigation sans rechargement de page (SPA).
 */

import { BrowserRouter as Router, Link, Routes, Route } from 'react-router-dom';
import Home from './components/home/Home.jsx';
import Login from './components/Login/Login.jsx';
import Search from './components/search/Search.jsx';
import Signup from './components/signup/Signup.jsx';
import Signupagence from './components/signupagence/Signupagence.jsx';
import VehicleDetail from './components/vehicleDetail/VehicleDetail.jsx';
import Payement from './components/payement/Payement.jsx';
import PaymentSuccess from './components/payement/PaymentSuccess.jsx';
import ChatPage from './components/chat/ChatPage.jsx';
import Profile from './components/profile/Profile.jsx';
import AdminDashboard from './components/admin/AdminDashboard.jsx';
import AgencyDashboard from './components/agence/AgencyDashboard.jsx';
import DiscusionInterface from './components/chat/DiscusionInterface.jsx';
import ResetPassword from './components/resetPassword/ResetPassword.jsx';
import AssistantIaPage from './components/AssistantAI/AssistantIaPage.jsx';
import VerifyEmail from './components/verifyEmail/VerifyEmail.jsx';
import About from './components/about/About.jsx';
import Contact from './components/contact/Contact.jsx';
import AgencyProfile from './components/agencyProfile/AgencyProfile.jsx';

function App() {
  return (
    <Router>
      <Routes>
        {/* ── Pages publiques ── */}
        <Route path="/"                    element={<Home />} />
        <Route path="/search"              element={<Search />} />
        <Route path="/about"               element={<About />} />
        <Route path="/contact"             element={<Contact />} />
        <Route path="/agency/:agencyName"  element={<AgencyProfile />} />

        {/* ── Détail véhicule & paiement ── */}
        <Route path="/vehicle/:id"         element={<VehicleDetail />} />
        <Route path="/payement"            element={<Payement />} />
        <Route path="/payment-success"    element={<PaymentSuccess />} />

        {/* ── Authentification ── */}
        <Route path="/login"               element={<Login />} />
        <Route path="/signup"              element={<Signup />} />
        <Route path="/signupagence"        element={<Signupagence />} />
        <Route path="/reset-password"      element={<ResetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/verify-email"        element={<VerifyEmail />} />

        {/* ── Espace connecté ── */}
        <Route path="/profile"             element={<Profile />} />
        <Route path="/messages"            element={<DiscusionInterface />} />
        <Route path="/chat/:agencySlug"    element={<ChatPage />} />
        <Route path="/assistant-ia"        element={<AssistantIaPage />} />

        {/* ── Dashboards ── */}
        <Route path="/admin"               element={<AdminDashboard />} />
        <Route path="/agence"              element={<AgencyDashboard />} />

        {/* ── Page 404 ── */}
        <Route
          path="*"
          element={(
            <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', color: '#eef7ff', padding: '1rem' }}>
              <div style={{ textAlign: 'center' }}>
                <h1 style={{ marginBottom: '0.8rem' }}>Page introuvable</h1>
                <p style={{ marginBottom: '1rem' }}>Verifiez l'URL puis revenez a la connexion.</p>
                <Link to="/login" style={{ color: '#8adfff', fontWeight: 700 }}>Aller a la connexion</Link>
              </div>
            </div>
          )}
        />
      </Routes>
    </Router>
  );
}

export default App;
